<style lang="scss" scoped>
@import 'common/sass/reuse.SCSS';
.search-box .select-type {
    margin-right: 0px;
}
.more-select {
    margin-top: 37px;
}
.select-type {
    .date-range-type {
        width: 117px;
    }
    .date-range-value {
        width: 243px;
    }
}

.search-btn {
    margin-top: 34px;
}
/deep/ .d-header {
    display: grid;
    .tool-selPage {
        margin-top: 25px;
        text-align: right;
        order: 3;
    }
}
/deep/ .pull-left {
    .btn-default {
        margin-top: 33px;
        float: right;
    }
}
.extraSearch {
    order: 2;
    .searchDiv {
        margin-left: 0;
    }
}
.control-table-header {
    order: 3;
    margin-top: -41px;
    width: 50%;
}
</style>

<template>
  <div :element-loading-text="loadText" class="maintenance-box" v-loading="loading">
    <div class="panel">
      <reuse-table
        :jsonExcelAjax="jsonExcelAjax"
        :name="name"
        :page="page"
        :selPage="selPage"
        :sort="sort"
        :tableHead="vTableHeader"
        :tbodyData="tbodyData"
        @tableChange="requestEngine"
      >
        <el-row class="search-box" slot="search" :gutter="20">
          <el-col class="select-type more-select" :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
            <el-switch :active-text="reuse.moreSelect" inactive-text v-model="more"></el-switch>
          </el-col>
          <el-col class="select-type" :xs="7" :sm="7" :md="7" :lg="7" :xl="7">
            <el-row>
                <span v-text="lan.CloseDateText"></span>
            </el-row>
            <el-row :gutter="10">
                <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                    <el-select @change="changeTime" v-model="type" class="date-range-type">
                        <el-option :key="key" :label="val" :value="key" v-for="(val, key) in reuse.typeMaps"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16">
                    <el-date-picker
                        :default-time="['00:00:00', '00:00:00']"
                        :disabled="canSelect"
                        :end-placeholder="lan.endTime"
                        :start-placeholder="lan.startTime"
                        type="daterange"
                        unlink-panels
                        v-model="closeTime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        class="date-range-value"
                    ></el-date-picker>
                </el-col>
            </el-row>
          </el-col>
          <el-col class="select-type" :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
            <el-row>
                <span v-text="lan.pointText"></span>
            </el-row>
            <el-row>
                <el-input clearable v-model="pointVal"></el-input>
            </el-row>
          </el-col>
          <el-col class="select-type" :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
            <el-row>
                <span v-text="lan.profitText"></span>
            </el-row>
            <el-row>
                <el-input clearable v-model="profit"></el-input>
            </el-row>
          </el-col>
          <el-col class="select-type" :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
              <el-row>
                <span v-text="lan.ownTimeText"></span>
              </el-row>
              <el-row>
                <el-input clearable v-model="ownTime"></el-input>
              </el-row>
          </el-col>
          <el-col class="select-type search-btn" :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
            <el-button @click="searchHandle" type="primary" v-text="reuse.searchText"></el-button>
          </el-col>
        </el-row>
        <el-row class="extraSearch" slot="more-filters" v-show="more" :gutter="20">
          <el-col class="searchDiv" :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
            <el-row>
                <span v-text="lan.securityText"></span>
            </el-row>
            <el-row>
                <el-select collapse-tags multiple v-model="security">
                    <el-option
                        :key="key"
                        :label="val.TYPE"
                        :value="val.TYPE"
                        v-for="(val, key) in securityList"
                    ></el-option>
                </el-select>
            </el-row>
          </el-col>
          <el-col class="searchDiv" :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
            <el-row>
                <span v-text="lan.loginText"></span>
            </el-row>
            <el-row>
                <el-input clearable v-model="login"></el-input>
            </el-row>
          </el-col>
          <el-col class="searchDiv" :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
            <el-row>
                <span v-text="lan.ibNumText"></span>
            </el-row>
            <el-row>
                <el-input clearable v-model="ibNum"></el-input>
            </el-row>
          </el-col>
          <el-col class="searchDiv" :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
            <el-row>
                <span v-text="reuse.officeText"></span>
            </el-row>
            <el-row>
                <el-input clearable v-model="office"></el-input>
            </el-row>
          </el-col>
          <el-col class="searchDiv" :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
            <el-row>
                <span v-text="reuse.regionText"></span>
            </el-row>
            <el-row>
                <el-input clearable v-model="region"></el-input>
            </el-row>
          </el-col>
          <el-col class="searchDiv" :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
            <el-row>
                <span v-text="lan.symbolText"></span>
            </el-row>
            <el-row>
                <el-input clearable v-model="symbol"></el-input>
            </el-row>
          </el-col>
        </el-row>
        <el-row class="control-table-header" slot="more-filters">
            <el-col>
                <multiple-select 
                    :initRemember="initRemember" 
                    :initSelectValues="visibleTableHeaders" 
                    :options="tableHead" 
                    :initPlaceholder="initPlaceholder"
                    @change="hideTableHeader"
                ></multiple-select>
            </el-col>
        </el-row>
      </reuse-table>
    </div>
  </div>
</template>
<script>
import { URL_PROFITREPORT, URL_TIMEDIFF, URL_SECURITY } from 'api/api'
import reuseTable from 'components/reuseTable'
import multipleSelect from 'components/multipleSelect'
import { getToDay, getCurrentMT4Time, getWeekStartAndEnd, getMonthStartAndEnd } from 'common/js/util'
export default {
    mixins: [
        require('common/mixin/base').base({ lan: 'dayTradeReport' }), 
        require('common/mixin/base').base({ reuse: 'reuse' })
    ],
    data() {
        return {
            loading: false,
            loadText: '',
            closeTime: [],
            pointVal: 50,
            ownTime: 3,
            profit: '',
            tbodyData: [],
            more: false,
            login: '',
            ibNum: '',
            symbol: '',
            type: '0',
            office: null,
            region: null,
            security: ['ALL'],
            canSelect: true,
            intervalID: '',
            timeDiff: 0,
            securityList: [],
            page: {
                active: 1,
                pageLeng: 0,
                offset: 0
            },
            selPage: {
                list: ['5', '10', '25', '50'],
                active: 1,
                limit: 10
            },
            sort: {
                list: 'All',
                active: { key: 'Close_Time', order: 'DESC' }
            },
            visibleTableHeaders: [],
            initRemember: false,
            userRememberItem: '',
            maxCloseTime: null,
        }
    },
    computed: {
        tableHead() {
            const redColorColumns = ['Commission','Swaps','Profit','TOTAL_PL_MONTHLY','TOTAL_CLOSE_PL','TOTAL_FLOATING_PL','TOTAL_PL']
            this.lan.tableHead.forEach(head => {
                if(redColorColumns.includes(head.key)) head.redColor = true;
            })
            return this.lan.tableHead
        },
        vTableHeader() {
            return this.lan.tableHead.filter(item => this.visibleTableHeaders.includes(item.key))
        },
        initPlaceholder() {
            return this.reuse.showMoreColumns
        },
        name() {
            return this.lan.downloadName
        },
        jsonExcelAjax() {
            return {
                url: URL_PROFITREPORT,
                ajaxType: 'get',
                getKey: ['data', 'data', 'data'],
                ajaxPar: {
                    pageSize: -1,
                    pageNum: 0,
                    closeTime: this.closeTime,
                    pointVal: this.pointVal,
                    ownTime: this.ownTime,
                    profit: this.profit,
                    login: this.login,
                    ibNum: this.ibNum,
                    office: this.office,
                    region: this.region,
                    symbol: this.symbol,
                    security: this.security,
                    sortKey: this.sort.active.key,
                    order: this.sort.active.order
                }
            }
        }
    },
    components: {
        reuseTable,
        multipleSelect,
    },
    created() {
        this.userRememberItem = `${(JSON.parse(sessionStorage.getItem("user")) || {}).name}DayTradeReportVisible`;
        const visible = localStorage.getItem(this.userRememberItem);
        if(visible) {
            this.initRemember = true;
            this.visibleTableHeaders = JSON.parse(visible);
        } else {
            this.visibleTableHeaders = this.lan.tableHead.map(v=> v.key)
        }
        this.$http.get(URL_TIMEDIFF).then(res => {
            this.timeDiff = res.data.data.diff
            this.closeTime = getToDay(this.timeDiff)
            this.$http.get(URL_SECURITY).then(res => {
                if (Object.prototype.toString.call(res.data.data) === '[object Array]') this.securityList = res.data.data
                this.securityList.push({ TYPE: 'ALL' })
                this.requestEngine()
            })
            this.$nextTick(function() { this.intervalID = setInterval(this.searchHandle, 6e4) })
        }).catch(e => {
            alert(this.reuse.serverError)
        })
    },
    destroyed() {
        clearInterval(this.intervalID)
    },
    methods: {
        searchHandle() {
            this.page.active = 1
            this.requestEngine()
        },
        requestEngine() {
            if (!this.closeTime) {
                this.$message({ message: this.reuse.selectTimeText, type: 'warning' })
                return
            }
            let option = { params: {} }
            option.params.closeTime = this.closeTime
            option.params.pageNum = this.page.active
            option.params.pageSize = +this.selPage.limit
            option.params.security = this.security

            let paramsArr = ['pointVal', 'ownTime', 'profit', 'login', 'ibNum', 'office', 'region']
            for (let val of paramsArr) {
                if (this[val] && this.tipMessage(this[val])) return
            }

            paramsArr.push('symbol')
            for (let val of paramsArr) {
                if (this[val]) option.params[val] = this[val]
            }

            if (this.sort.active.order) {
                option.params.sortKey = this.sort.active.key
                option.params.order = this.sort.active.order
            }
            this.loading = true
            this.$http.get(URL_PROFITREPORT, option).then(res => {
                if (Object.prototype.toString.call(res.data.data.data) === '[object Array]') {
                    this.page.pageLeng = res.data.data.count
                    this.tbodyData = res.data.data.data
                } else {
                    this.tbodyData = []
                    this.page.pageLeng = 0
                }
                this.loading = false
                if(this.maxCloseTime) {
                    this.tbodyData.map(item => {
                        const closeStr = `${item.Close_Date} ${item.Close_Time}`
                        item.bgColor = this.$moment(closeStr).isAfter(this.maxCloseTime)
                    })
                    return;
                }
                // const latest = this.tbodyData[0] || {}
                // const closeTimeStr = `${latest.Close_Date} ${latest.Close_Time}`
                // const close = closeTimeStr ? closeTimeStr : getCurrentMT4Time(this.timeDiff)
                const close = getCurrentMT4Time(this.timeDiff)
                this.maxCloseTime = this.$moment(close)
            })
            .catch(e => {
                alert(this.reuse.serverError)
            })
        },
        tipMessage(value, message) {
            if (isNaN(new Number(value))) {
                this.$message({ message: this.reuse.pleaseInputNumber, type: 'warning' })
                this.tbodyData = []
                this.page.pageLeng = 0
                return true
            }
        },
        changeTime() {
            if (this.type == '3') {
                this.canSelect = false
                return
            }
            this.canSelect = true
            switch (this.type) {
            case '0':
                this.closeTime = getToDay(this.timeDiff)
                break
            case '1':
                this.closeTime = getWeekStartAndEnd(0, this.timeDiff)
                break
            case '2':
                this.closeTime = getMonthStartAndEnd(0, this.timeDiff)
                break
            default:
                break
            }
            this.searchHandle()
        },
        hideTableHeader(selectedVal) {
            const rememberKey = this.reuse.rememberMyChoice.key
            if(selectedVal.includes(rememberKey)) {
                const visibleStr = JSON.stringify(selectedVal.filter(key => ![this.reuse.selectAll.key, rememberKey].includes(key)))
                localStorage[this.userRememberItem] = visibleStr
            } else {
                localStorage.removeItem(this.userRememberItem)
            }
            this.visibleTableHeaders = selectedVal;
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/views/report/day-trade-report.vue